import { gql } from "@apollo/client";

export const getAllTrialCalendarQuery = gql`
  query GetAllTrialCalendar(
    $pageNumber: Int!
    $pageSize: Int!
    $search: String
    $approvalStatus: String
    $role: String
    $type: String
    $trialStatus : String
  ) {
    getAllTrialCalendar(
      pageNumber: $pageNumber
      pageSize: $pageSize
      search: $search
      role: $role
      approvalStatus: $approvalStatus
      type: $type
      trialStatus: $trialStatus
    ) {
      data {
        id
        trial {
          trialName
          id
          status
        }
      }
      pageNumber
      pageSize
      totalDocs
      totalPages
      totalCount
    }
  }
`;

export const getAllTrialCalendarForTrailDrawQuery = gql`
  query GetAllTrialCalendarForTrailDraw {
      getAllTrialCalendarForTrailDraw {
      id
      authId
      trail {
        id
        trialName
        trialLocationName
        trialLocationAddress
        city
        state
        zip
        timezone
        trialDate
        openDate
        closeDate
        trialFile
        description
        notes
        noOfJudge
        trialFees
        maxEntries
        trialImages
        judgeAuthId
        status
        approvalStatus
      }
    }
  }
`;

export const getRandomDogsTrialByTrialCalendarQuery = gql`
  query GetRandomDogsTrialByTrialCalendar(
    $pageNumber: Int!
    $pageSize: Int!
    $trialCalendarId: Int!
    $isPaginated: Boolean!
  ) {
    getRandomDogsTrialByTrialCalendar(
      pageNumber: $pageNumber
      pageSize: $pageSize
      trialCalendarId: $trialCalendarId
      isPaginated: $isPaginated
    ) {
      pageNumber
      pageSize
      totalDocs
      totalDraw
      totalPages
      totalCount
      downloadUrl
      message
      drawnTrial {
        id
        dog
        division
        authId
        element
        breed
        trialCalendarId
        memberName
        email
        address
        phoneNumber
        emergencyContactName
        emergencyContactNumber
      }
      data {
        id
        dog
        division
        authId
        element
        breed
        trialCalendarId
        memberName
        email
        address
        phoneNumber
        emergencyContactName
        emergencyContactNumber
      }
    }
  }
`;

export const generateEntriesEmailNotificationMutation = gql`
  mutation GenerateEntriesEmailNotification($trialCalendarId: Int!)  {
    generateEntriesEmailNotification(trialCalendarId: $trialCalendarId) {
      message
    }
  }
`;

export const getRemainingTrialForDrawQuery = gql`
  query GetRemainingTrialForDraw($trialCalendarId: Int!) {
    getRemainingTrialForDraw(trialCalendarId: $trialCalendarId) {
      id
      dog
      elements
      division
      memberName
    }
  }
`;

export const removeSelectedDraw = gql`
  mutation RemoveSelectedDraw($trialCalendarId: Int!, $trialDrawnId: Int!) {
    removeSelectedDraw(trialCalendarId: $trialCalendarId, trialDrawnId: $trialDrawnId ) {
      message
    }
  }
`;

export const patchNewEntriesToSelectedDrawMutation = gql`
  mutation PatchNewEntriesToSelectedDraw(
    $trialDogs: [PatchNewEntriesInput!]!
    $pageNumber: Int!
    $pageSize: Int!
  ) {
    patchNewEntriesToSelectedDraw(
      trialDogs: $trialDogs
      pageNumber: $pageNumber
      pageSize: $pageSize
    ) {
      data {
        id
        dog
        division
        authId
        breed
        element
        trialCalendarId
        memberName
        email
        address
        phoneNumber
        emergencyContactName
        emergencyContactNumber
      }
      pageNumber
      pageSize
      totalDocs
      totalPages
      totalCount
      downloadUrl
    }
  }
`;

export const cancelRandomDrawMutation = gql`
  mutation CancelRandomDraw($trialCalendarId: Int!) {
    cancelRandomDraw(trialCalendarId: $trialCalendarId) {
      message
    }
  }
`;
